
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/photo-translator",
      function () {
        return require("private-next-pages/photo-translator/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/photo-translator"])
      });
    }
  